import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertUtcDateToTimezone } from '@utils/dates/dateMethods';
import { environmentSelector } from '@selectors/commonSelectors';

/**
 * Hook that provides the current server date.
 * Returns a Date object that displays as server time when rendered in date pickers.
 * 
 * This creates a "fake local" Date where the displayed time values match the server's
 * local time, regardless of the user's browser timezone.
 * 
 * @returns Date - The server date at the time the page loaded
 */
const useCurrentServerDate = (): Date => {
    const localDates = useSelector(environmentSelector)?.localDates;

    // Server date at page load time (for display in date pickers)
    return useMemo(() => {
        if (!localDates) return new Date();
        const { serverDateInUTC, timezoneOffsetMs, dstSavingsMs } = localDates;
        return convertUtcDateToTimezone(serverDateInUTC, Number(timezoneOffsetMs), Number(dstSavingsMs));
    }, [localDates]);
};

export default useCurrentServerDate;
